export default __webpack_public_path__ + "static/media/cartNew.20a7d342.svg";